import React, { memo } from 'react';

import Rating from '@prisjakt/ui-rating';
import RatingHelper from '@prisjakt/ui-rating/src/rating-helper';
import { StarIcon } from '@prisjakt/ui-icons';
import T from '@prisjakt/ui-translate';

import * as S from './styles';

const SCALE = 5;

type Props = {
  className?: string;
  rating: number;
  count: number;
  distribution: number[];
};

const ReviewsSummary = ({ className, rating, count, distribution }: Props) => {
  if (!rating || !count || !distribution) return null;

  return (
    <S.SummaryWrapper className={className}>
      <S.Summary>
        <S.Score>
          <S.Value>{RatingHelper.toRounded(rating)}</S.Value> / {SCALE}
        </S.Score>
        <S.RatingWrapper>
          <Rating
            centerAlign
            size="large"
            rate={rating}
            count={count}
            showCounter={false}
          />

          <T domain="reviews" n={count}>
            rating.n-reviews
          </T>
        </S.RatingWrapper>
      </S.Summary>

      {distribution && count >= SCALE && (
        <S.Distribution>
          {distribution.map((ratingCount, index) => {
            const rate = SCALE - index;
            const ratio = Math.round((ratingCount / count) * 100);

            return (
              <>
                <S.MeterLabel>
                  {rate} <StarIcon height={12} styling="active" />
                </S.MeterLabel>
                <S.Meter>
                  <S.Indicator width={`${ratio}%`} />
                </S.Meter>
                <S.MeterLabel>({ratingCount})</S.MeterLabel>
              </>
            );
          })}
        </S.Distribution>
      )}
    </S.SummaryWrapper>
  );
};

export default memo(ReviewsSummary);
